'use client';

import { FC, PropsWithChildren, useEffect, useMemo, useState } from 'react';
import ReactDOM from 'react-dom';

interface PortalProps {
  id?: string;
  defaultContainer?: Element | null;
}

const Portal: FC<PropsWithChildren<PortalProps>> = ({ children, id, defaultContainer }) => {
  const [mounted, setMounted] = useState(false);

  const container = useMemo(() => {
    if (defaultContainer) {
      return defaultContainer;
    }

    if (!id) {
      throw new Error('One of props id or defaultContainer isRequired');
    }

    if (typeof document === 'undefined') {
      return null;
    }

    let element = document.getElementById(id);
    if (!element) {
      element = document.createElement('div');
      element.setAttribute('id', id);
      document.body.appendChild(element);
    }

    return element;
  }, [id, defaultContainer]);

  useEffect(() => {
    setMounted(true);
  }, []);

  if (!mounted || !container) {
    return null;
  }

  return ReactDOM.createPortal(children, container);
};

export default Portal;
